import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { LoadingButton } from '@mui/lab'
import { Autocomplete, Box, Stack, Typography } from '@mui/material'
import TextField from 'components/TextField'
import Paper from 'components/paper'
import { InfoSkeleton } from 'components/skeleton'
import { Form, Formik } from 'formik'
import { COLORS } from 'styles/colors'
import { EntityList } from 'types/profile'
import useCompanyConfig from '../hooks/useCompanyConfig'
import useSettings from '../hooks/useSettings'

export default function JobsSettinggs() {
  const { saving, isLoading, entity, companyEntity, selectedField } =
    useSettings('job')

  const { onUpdateStep, isLoading: sending } = useCompanyConfig(true)

  const validateEntities = entity.map(item => {
    const validateName = item.replace(/_/g, ' ')
    return { value: item, label: validateName }
  })

  const updatedField: any = selectedField?.reduce((acc, current) => {
    const label = current.label.replace(/ /g, '_')
    return { ...acc, [label]: current }
  }, {})

  const initialValues = validateEntities.reduce((acc, current) => {
    return {
      ...acc,
      [current.value]:
        updatedField && updatedField[current.value]
          ? updatedField[current.value].value
          : ''
    }
  }, {} as { [key in EntityList]: string })

  const atsOptions =
    companyEntity.map(option => {
      return { name: option.key, label: option.key }
    }) || []

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={values => onUpdateStep(values, 'job')}
    >
      {({ setFieldValue, values }) => (
        <Stack component={Form} justifyContent="space-between" padding={2}>
          <Stack marginBottom={3}>
            <Typography fontSize="14px" fontWeight="500" paddingTop={2}>
              Data field mapping
            </Typography>
            <Typography fontSize="14px" fontWeight="400" paddingTop={2}>
              Customize data fields by synced from Beegopp to the ATS
            </Typography>
          </Stack>
          <Box component={Paper} marginBottom={3}>
            {isLoading ? (
              <InfoSkeleton />
            ) : (
              <>
                <Stack paddingBottom={2}>
                  <Typography fontSize="14px" fontWeight="500">
                    Data field mapping
                  </Typography>
                </Stack>
                <Stack paddingY={2}>
                  <Stack flexDirection="row">
                    <Typography
                      fontSize="14px"
                      fontWeight="400"
                      width="50%"
                      color={COLORS.gray2}
                    >
                      Beegopp field
                    </Typography>
                    <Typography
                      fontSize="14px"
                      fontWeight="400"
                      width="50%"
                      color={COLORS.gray2}
                    >
                      ATS field
                    </Typography>
                  </Stack>
                  <Stack flexDirection="column" paddingTop="20px">
                    {validateEntities.map((item, index) => (
                      <Box
                        key={index}
                        width="100%"
                        display="flex"
                        paddingBottom={2}
                        flexDirection="row"
                        alignItems="flex-end"
                        justifyContent="space-between"
                      >
                        <Stack flexDirection="row" width="50%">
                          <Typography
                            width="50%"
                            variant="h5"
                            textTransform="capitalize"
                          >
                            {item.label}
                          </Typography>
                          <ArrowForwardIcon
                            htmlColor={COLORS.honey4}
                            sx={{ width: '40%' }}
                          />
                        </Stack>
                        <Autocomplete
                          disablePortal
                          options={atsOptions}
                          getOptionLabel={option => option.label || ''}
                          value={{
                            name: values[item.value as EntityList],
                            label: values[item.value as EntityList]
                          }}
                          onChange={(_, option) => {
                            setFieldValue(item.value, option?.name || '')
                          }}
                          sx={{ width: '50%' }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label="Search value"
                              name={item.value}
                              variant="standard"
                            />
                          )}
                        />
                      </Box>
                    ))}
                  </Stack>
                </Stack>
              </>
            )}
          </Box>
          <LoadingButton
            fullWidth
            type="submit"
            variant="contained"
            loading={saving || sending}
            disabled={isLoading || saving || sending}
            sx={{
              marginBottom: 2
            }}
          >
            Continue
          </LoadingButton>
        </Stack>
      )}
    </Formik>
  )
}
